import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = {
  checkoutSettingsId?: string;
};
function useFetchCheckoutSettings({checkoutSettingsId}: Props) {
  const {getCheckoutSetting} = useChekinSDK();

  return useQuery(
    [QUERY_CACHE_KEYS.checkoutSettings],
    () => getCheckoutSetting(checkoutSettingsId!),
    {
      enabled: Boolean(checkoutSettingsId),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
}

export {useFetchCheckoutSettings};
